import React from "react";
import {
  Card,
  CardContent,
  Grid,
  FormControl,
  TextField,
  CardActions,
  Button,
  Switch,
  createStyles,
  makeStyles,
  withStyles,
  ButtonGroup,
  IconButton,
  Typography,
} from "@material-ui/core";
import { useVehicle } from "context";
import { useUpdateVehicle } from "rest";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const RedSwitch = withStyles({
  switchBase: {
    color: "#FF0000",
  },
  checked: {},
  track: {},
})(Switch);

const useStyles = makeStyles(() =>
  createStyles({
    cardActions: {
      padding: 16,
    },
  })
);

export const PendantVehicleForm = ({ savedVehicle }) => {
  const classes = useStyles();

  const {
    vehicles,
    setVehicles,
    setCheckedC,
    setSavedVehicle,
    setCard1,
    setCard2,
    setPendantVehicleForm,
    setChecked,
    setCheckedE,
    setTrigger,
    trigger,
    prev,
  } = useVehicle();

  const { mutate: updateVehicle } = useUpdateVehicle({
    onSuccess: () => {
      setSavedVehicle(false);
      setChecked(true);
      setTimeout(() => {
        setChecked(false);
      }, 5000);
    },
    onError: () => {
      setCheckedE(true);
      setTimeout(() => {
        setCheckedE(false);
      }, 5000);
    },
  });

  const savePendant = () => {
    // let first = Object.keys(vehicles).filter((key) => vehicles[key] === "");
    let second = Object.keys(vehicles.pendant).filter((key) => vehicles.pendant[key] === "");
    if (second.length > 0) {
      setCheckedC(true);
      setSavedVehicle(true);
      setTimeout(() => {
        setCheckedC(false);
      }, 5000);
    } else {
      let updateVehicleObject = {
        lengthInM: vehicles.lengthInM.replace(",", "."),
        numberplate: vehicles.numberplate.toString(),
        pendantLengthInM: vehicles.pendant.lengthInM.replace(",", "."),
        pendantNumberplate: vehicles.pendant.numberplate.toString(),
        isPendantActive: vehicles.pendant.isPendantActive,
        carLengthInM: vehicles.car.lengthInM.replace(",", "."),
        carNumberplate: vehicles.car.numberplate.toString(),
        isCarActive: vehicles.car.isCarActive,
        isVehicleActive: vehicles.isVehicleActive,
        hasMoto: vehicles.hasMoto,
        hasBike: vehicles.hasBike,
        hasTent: vehicles.hasTent,
      };
      setCard2(1);
      updateVehicle(updateVehicleObject);
    }
  };

  const handleAddPendantLength = () => {
    if (parseInt(vehicles.pendant.lengthInM || 0) < 20) {
      setVehicles((vehicles) => ({
        ...vehicles,
        pendant: {
          ...vehicles.pendant,
          lengthInM: (parseInt(vehicles.pendant.lengthInM || 0) + 1).toString(),
        },
      }));
    }
  };

  const handleSubPendantLength = () => {
    if (parseInt(vehicles.pendant.lengthInM) > 0) {
      setVehicles((vehicles) => ({
        ...vehicles,
        pendant: {
          ...vehicles.pendant,
          lengthInM: (parseInt(vehicles.pendant.lengthInM) - 1).toString(),
        },
      }));
    }
  };

  const handleChangePendantVehicle = (e: any) => {
    setVehicles((vehicles) => ({
      ...vehicles,
      pendant: {
        ...vehicles.pendant,
        [e.target.id]: e.target.value,
      },
    }));
  };

  const handlePendantActive = (e) => {
    if (e.target.checked) {
      vehicles.pendant[e.target.id] = true;
    } else {
      vehicles.pendant[e.target.id] = false;
    }
    setTrigger(!trigger);
  };

  const closePendant = () => {
    setPendantVehicleForm(false);
    setCard2(1);
    setVehicles(prev);
  };

  return (
    <Card style={{ marginTop: 18 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth variant="outlined">
              <TextField
                id={"numberplate"}
                defaultValue={vehicles.pendant.numberplate}
                onChange={handleChangePendantVehicle}
                variant="outlined"
                label="Kennzeichen"
                required
                helperText={vehicles.pendant.numberplate === "" && savedVehicle === true ? "Pflichtfeld" : ""}
                error={vehicles.pendant.numberplate === "" && savedVehicle === true ? true : false}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={8} md={10}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    id={"lengthInM"}
                    value={vehicles.pendant.lengthInM}
                    onChange={handleChangePendantVehicle}
                    variant="outlined"
                    label="Länge in Meter"
                    helperText={
                      vehicles.pendant.lengthInM === "" && savedVehicle === true ? "Pflichtfeld" : ""
                    }
                    error={vehicles.pendant.lengthInM === "" && savedVehicle === true ? true : false}
                    required
                    onInput={(e: any) => {
                      e.target.value =
                        e.target.value.includes(".") || e.target.value.includes("-")
                          ? ""
                          : e.target.value === "0"
                          ? ""
                          : e.target.value.includes(",")
                          ? e.target.value.indexOf(",") === 2
                            ? e.target.value.toString().slice(0, 5)
                            : e.target.value.toString().slice(0, 4)
                          : Number(parseFloat(e.target.value).toString().slice(0, 2)) < 20
                          ? e.target.value.toString().slice(0, 2)
                          : e.target.value.toString().slice(0, 1);
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={2} style={{ paddingTop: "7px" }}>
                <ButtonGroup
                  size="small"
                  variant="outlined"
                  disableElevation
                  orientation="vertical"
                  color="primary"
                >
                  <Button style={{ height: "28px" }} size="small" onClick={handleAddPendantLength}>
                    <ArrowUpwardIcon />
                  </Button>
                  <Button style={{ height: "28px" }} size="small" onClick={handleSubPendantLength}>
                    <ArrowDownwardIcon />
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Grid item>
          <Button onClick={savePendant} variant="contained" color="primary" disableElevation>
            Wohnwagen/Anhänger Speichern
          </Button>
        </Grid>
        {/* <Grid item>
          {!vehicles.pendant.isPendantActive ? "Ohne " : "Mit"}
          <RedSwitch
            checked={vehicles.pendant.isPendantActive}
            onChange={handlePendantActive}
            id={"isPendantActive"}
            name="checkedB"
            color="primary"
          />
        </Grid> */}
        <Grid item style={{ marginLeft: "auto" }}>
          <Button onClick={closePendant} variant="contained" disableElevation>
            Abbrechen
          </Button>
        </Grid>
      </CardActions>
    </Card>
  );
};
